import { create } from 'zustand';

interface ScrollState {
  positions: Record<string, number>;
  savePosition: (key: string, position: number) => void;
  getPosition: (key: string) => number;
}

export const useScrollStore = create<ScrollState>()((set, get) => ({
  positions: {},
  savePosition: (key: string, position: number) =>
    set((state) => ({ positions: { ...state.positions, [key]: position } })),
  getPosition: (key: string) => get().positions[key] || 0,
}));
